import axios from "axios";
import { Platform } from "react-native";

export const BASE_URL =
  Platform.OS === "web" && window.location.hostname !== "localhost"
    ? window.location.protocol + "//" + window.location.host + "/"
    : process.env.EXPO_PUBLIC_API_URL;

const apiClient = axios.create({
  baseURL: `${BASE_URL}`,
});

export default apiClient;
